/**
 * Toast after successful PDP / product-form add-to-cart.
 * Also manages loading state on ATC buttons (card + PDP).
 * Listens for Theme cart:update (CartAddEvent); no external deps.
 */
(function () {
  'use strict';

  var TOAST_MS = 4500;
  var VISIBLE_CLASS = 'cart-add-toast--visible';
  var timers = [];

  /* ── ATC loading state ───────────────────────────────────────── */

  /**
   * Show loading state on an ATC button.
   * Works for both product-card-v2 and PDP buttons.
   * @param {HTMLButtonElement} btn
   */
  function setLoading(btn) {
    btn.disabled = true;
    btn.dataset.atcLoading = 'true';
    var spinner = btn.querySelector('.atc-spinner');
    if (spinner) {
      spinner.removeAttribute('hidden');
    }
  }

  /**
   * Clear loading state.
   * @param {HTMLButtonElement} btn
   */
  function clearLoading(btn) {
    btn.disabled = false;
    delete btn.dataset.atcLoading;
    var spinner = btn.querySelector('.atc-spinner');
    if (spinner) {
      spinner.setAttribute('hidden', '');
    }
  }

  // On form submit inside any product-form-component, show loading state.
  document.addEventListener(
    'submit',
    function (e) {
      var form = /** @type {HTMLFormElement} */ (e.target);
      if (!form || !form.closest('product-form-component')) return;
      var btn = /** @type {HTMLButtonElement | null} */ (
        form.querySelector('.product-card-v2__add-btn, .pdp-atc-btn')
      );
      if (!btn) return;
      setLoading(btn);
      // Fallback: if cart:update never fires (network error), clear after 6s.
      setTimeout(function () {
        if (btn.dataset.atcLoading === 'true') clearLoading(btn);
      }, 6000);
    },
    true
  );

  // Reset all loading buttons when the cart updates (success or error).
  document.addEventListener('cart:update', function () {
    document
      .querySelectorAll('[data-atc-loading="true"]')
      .forEach(function (btn) {
        clearLoading(/** @type {HTMLButtonElement} */ (btn));
      });
  });

  function clearTimers() {
    timers.forEach(function (id) {
      clearTimeout(id);
    });
    timers.length = 0;
  }

  /**
   * @param {number} count
   * @returns {string}
   */
  function formatMessage(count) {
    var t = typeof Theme !== 'undefined' ? Theme.translations : null;
    if (!t) return '';
    var n = count > 0 ? count : 1;
    if (n === 1) return t.items_added_to_cart_one || '';
    var tpl = t.items_added_to_cart_other || '';
    return tpl.replace(/\{\{\s*count\s*\}\}/g, String(n));
  }

  /**
   * @param {HTMLElement} el
   */
  function removeToast(el) {
    if (!el || !el.parentNode) return;
    el.classList.remove(VISIBLE_CLASS);
    var id = setTimeout(function () {
      el.remove();
    }, 280);
    timers.push(id);
  }

  /**
   * @param {string} message
   */
  function showToast(message) {
    clearTimers();
    var existing = document.getElementById('cart-add-toast');
    if (existing) existing.remove();

    var wrap = document.createElement('div');
    wrap.id = 'cart-add-toast';
    wrap.className = 'cart-add-toast';
    wrap.setAttribute('role', 'status');
    wrap.setAttribute('aria-live', 'polite');

    var inner = document.createElement('div');
    inner.className = 'cart-add-toast__inner';

    var p = document.createElement('p');
    p.className = 'cart-add-toast__message';
    p.textContent = message;

    var t = typeof Theme !== 'undefined' ? Theme.translations : null;
    var routes = typeof Theme !== 'undefined' ? Theme.routes : null;
    var linkLabel = t && t.view_cart ? t.view_cart : 'Cart';

    var a = document.createElement('a');
    a.className = 'cart-add-toast__link';
    a.href = routes && routes.cart_url ? routes.cart_url : '/cart';
    a.textContent = linkLabel;

    inner.appendChild(p);
    inner.appendChild(a);
    wrap.appendChild(inner);
    document.body.appendChild(wrap);

    requestAnimationFrame(function () {
      wrap.classList.add(VISIBLE_CLASS);
    });

    timers.push(
      setTimeout(function () {
        removeToast(wrap);
      }, TOAST_MS)
    );
  }

  document.addEventListener('cart:update', function (e) {
    var d = e.detail && e.detail.data;
    if (!d || d.source !== 'product-form-component' || d.didError) return;
    var msg = formatMessage(Number(d.itemCount) || 0);
    if (!msg && typeof Theme !== 'undefined' && Theme.translations) {
      msg = Theme.translations.added || '';
    }
    if (!msg) return;
    showToast(msg);
  });
})();
